import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function AttorneyForm() {
  const [phoneNumber, setPhonenumber] = useState("");
  const [nameSurename, setNameSurename] = useState("");
  const [email, setEmail] = useState("");

  const [attornetFirm, setAttorneyFirm] = useState("");

  const navigate = useNavigate();

  function sendMail() {
    console.log("Sending Email");

    if (nameSurename && email && phoneNumber) {
      localStorage.setItem("name", nameSurename);
      localStorage.setItem("email", email);
      localStorage.setItem("tel", phoneNumber);

      localStorage.setItem("attorneyFirm", attornetFirm);

      // Prepare the FormData to include attachments
      const formData = new FormData();
      formData.append(
        "message",
        `Name & Surname: ${nameSurename} <br/> Phone: ${phoneNumber} <br/> Email: ${email}  <br/> Attornet Firm: ${attornetFirm}`
      );
      formData.append("subject", "Attorney Bridging Finance Application");
      formData.append("to", "apply@webridge.co.za");

      // Attach a file if there is one
      const fileInput = document.getElementById("attachment"); // assume there’s an <input type="file" id="attachment">
      if (fileInput && fileInput.files.length > 0) {
        formData.append("attachment", fileInput.files[0]);
        formData.append("attachmentTwo", fileInput.files[0]);
      }

      axios
        .post("https://email-sender-lovat.vercel.app/send_Resend", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => alert("Message Sent"))
        .catch(() => alert("Failed to send email"));
      return navigate("/ThankYou");
    }

    return alert("Fill in all fields to continue");
  }
  return (
    <>
      <form action="">
        <input
          className=" form-control"
          type="text"
          placeholder="Name & Surname"
          value={nameSurename}
          onChange={(e) => setNameSurename(e.target.value)}
        />

        <input
          className=" form-control"
          type="text"
          placeholder="Attorney Firm Name"
          value={attornetFirm}
          onChange={(e) => setAttorneyFirm(e.target.value)}
        />
        <input
          className=" form-control"
          type="tel"
          placeholder="Phone number"
          value={phoneNumber}
          onChange={(e) => setPhonenumber(e.target.value)}
        />
        <input
          className=" form-control"
          type="email"
          placeholder="E-mail Adress"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <button onClick={() => sendMail()} className=" btn btn-primary">
          Submit
        </button>
      </form>
    </>
  );
}
export default AttorneyForm;
